<ng-container *ngIf="displayType !== cardDisplayType.checklist">
  <ng-container *ngIf="!useAlternate; else staticBackup">
    <div class="animation-container">
      <div class="good-job-text">Action Complete!</div>
      <canvas
        class="animation-canvas"
        artboard="Artboard"
        riv="action-complete"
        [height]="canvasHeight"
        [width]="canvasWidth">
        <riv-player name="NiceJob!" [play]="playAnimation" (load)="loaded()"></riv-player>
      </canvas>
    </div>
  </ng-container>

  <ng-template #staticBackup>
    <div class="animation-container">Action Complete!</div>
  </ng-template>
</ng-container>
